/* Obvestilo ob dodajanju/odstranjevanju z liste zelja.
   Tema (Ella 6.4.2) ob kliku na .wishlist-icon samo preklopi razred in
   localStorage kljuc "wishlistItem" - brez povratne informacije. Tu ne
   posegamo v njen handler: poslusamo isti klik, primerjamo stanje shrambe
   pred in po njem ter pokazemo kratek toast. */
(function () {
  "use strict";

  var ZIVLJENJE = 3500;
  var skrijTimer = null;

  function preberi() {
    try { return JSON.parse(localStorage.getItem("wishlistItem") || "[]").length; }
    catch (e) { return 0; }
  }

  function toastEl() {
    var el = document.getElementById("szq-wl-toast");
    if (el) return el;
    el = document.createElement("div");
    el.id = "szq-wl-toast";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");
    el.innerHTML =
      '<span class="szq-wl-toast-ikona" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M12 21s-7.5-4.9-9.7-9A5.6 5.6 0 0 1 12 6.1 5.6 5.6 0 0 1 21.7 12c-2.2 4.1-9.7 9-9.7 9z"/></svg>' +
      "</span>" +
      '<span class="szq-wl-toast-besedilo"></span>' +
      '<a class="szq-wl-toast-povezava" href="/pages/wish-list">Poglej listo</a>';
    document.body.appendChild(el);
    return el;
  }

  function pokazi(dodano) {
    var el = toastEl();
    el.querySelector(".szq-wl-toast-besedilo").textContent = dodano
      ? "Izdelek je dodan na listo želja."
      : "Izdelek je odstranjen z liste želja.";
    el.querySelector(".szq-wl-toast-povezava").style.display = dodano ? "" : "none";
    el.classList.add("szq-wl-toast-viden");
    clearTimeout(skrijTimer);
    skrijTimer = setTimeout(function () {
      el.classList.remove("szq-wl-toast-viden");
    }, ZIVLJENJE);
  }

  document.addEventListener("click", function (e) {
    var gumb = e.target.closest && e.target.closest(".wishlist-icon");
    if (!gumb) return;
    /* na strani liste sluzi gumb odstranjevanju iz tabele - tam je ucinek
       viden neposredno in bi toast samo motil */
    if (gumb.closest(".halo-wishlist-content")) return;
    var prej = preberi();
    setTimeout(function () {
      var potem = preberi();
      if (potem === prej) return; /* handler teme ni tekel ali pa se ni koncal */
      pokazi(potem > prej);
    }, 120);
  });
})();
